/**
 * Service layer per la disiscrizione dalle newsletter (pagina pubblica, no login).
 *
 * Il link dell'email (GET /n/u/{token}) porta alla pagina di conferma senza disiscrivere:
 * la disiscrizione avviene solo con questi POST, alla conferma dell'utente.
 * Il token identifica il destinatario; token non valido → 404.
 */
import API from '../../api';

export const unsubscribeApi = {
  /** POST /n/u/{token} — disiscrizione da tutte le newsletter → { status, scope }. */
  confirmGlobal: (token) => API.post(`/n/u/${token}`),

  /** POST /n/u/{token}/entity — blocco della sola entità mittente → { status, scope, entity? }. */
  confirmEntity: (token) => API.post(`/n/u/${token}/entity`),

  /**
   * POST /n/r/{token} — annulla il blocco dell'entità mittente (link dell'email di cortesia)
   * → { status, entity?, allow_news? }. allow_news=false: l'utente ha anche il blocco globale.
   */
  confirmResubscribe: (token) => API.post(`/n/r/${token}`),

  /** POST /n/r/{token}/global — riattiva tutte le newsletter (allow_news = true) → { status, scope }. */
  confirmResubscribeGlobal: (token) => API.post(`/n/r/${token}/global`),
};

export default unsubscribeApi;
